import { IChargeMasterModel } from "./charge-master";

export interface IChargeGroup {
    id: string;
    is_active: boolean;
    name: string;
    charges: string[] | IChargeMasterModel[];
    description: string;
}

export interface IChargeGroupError {
    id: string[];
    name: string[];
    charges: string[];
    description: string[];
}

export class ChargeGroupModel implements IChargeGroup {
    id: string;
    is_active: boolean;
    name: string;
    charges: string[] | IChargeMasterModel[];
    description: string;

    error: IChargeGroupError;

    constructor() {
        this.id = null;
        this.is_active = true;
        this.name = null;
        this.charges = [];
        this.description = null;

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            id: [],
            name: [],
            charges: [],
            description: [],
        }
    }

    saveChargeGroupToPayload(data) {
        this.id = data.id;
        this.is_active = data.is_active;
        this.name = data.name;
        this.charges = data.charges;
        this.description = data.description;
    }

    getSavePayload() {
        return {
            is_active: this.is_active,
            name: this.name,
            charges: this.charges.map(item => item?.id),
            description: this.description,
        }
    }

    checkChargeGroupErrors() {
        return this.error.name.length == 0
            && this.error.charges.length == 0
            && this.error.description.length == 0
    }

    mapChargeGroupErrors(err) {
        this.error.name = err.name?.length ? err.name : [];
        this.error.charges = err.charges?.length ? err.charges : [];
        this.error.description = err.description?.length ? err.description : [];
    }
}
